import {
  FYDEOS_NOTES_LOGO,
  getCurrentFydeOSBrandLinks,
} from '@affine/component/product-brand';
import { useLiveData, useService } from '@toeverything/infra';
import { useTheme } from 'next-themes';

import { AppSidebarService } from '../../services/app-sidebar';
import {
  navHeaderBrand,
  navHeaderBrandImage,
  navHeaderStyle,
} from '../index.css';
import { SidebarSwitch } from './sidebar-switch';

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const { resolvedTheme } = useTheme();
  const brandLinks = getCurrentFydeOSBrandLinks();

  return (
    <div className={navHeaderStyle} data-open={open}>
      <a href={brandLinks.notesHome} className={navHeaderBrand}>
        <img
          className={navHeaderBrandImage}
          src={
            resolvedTheme === 'dark'
              ? FYDEOS_NOTES_LOGO.dark
              : FYDEOS_NOTES_LOGO.light
          }
          alt="FydeOS Notes"
        />
      </a>
      <SidebarSwitch show={open} />
    </div>
  );
};

export * from './sidebar-switch';
